export class AssetLoader {

    //#region Fronta s assety k nacteni

    /**
     * Fronta
     */
    private _queue: pc.Asset[];

    /**
     * Celkovy pocet zaznamu ve fronte
     */
    private _queueSize: number;

    /**
     * Aktualni pozice ve fronte
     */
    private _queuePos: number;

    //#endregion

    //#region Paralerni nacitani

    /**
     * Maximalni pocet paralernich nacitani
     */
    private _maxPrlDownloads: number;

    /**
     * Aktualni pocet paralernich nacitani
     */
    private _prlDownloads: number;

    //#endregion

    /**
     * Celkovy pocet nactenych assetu
     */
    private _loadedCnt: number;

    private _assetRegistry: pc.AssetRegistry;
    private _urlPrefix: string;

    /**
     * Udalost vyvolana po dokonceni nacteni vsech assetu
     * Emitter: assetRegistry
     * Parametery: loader: AssetLoader, loadedCnt: number
     */
    static readonly EVENT_LOADED = "loader:loaded";

    /**
     * (RO) True, pokud probiha nacitani
     */
    get isLoading(): boolean { return this._isLoading; }
    private _isLoading: boolean;

    /**
     * (RO) Aktualni progress (0 az 1)
     */
    get progress(): number { return this._isLoading ? this._loadedCnt / this._queueSize : 0; }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(assetRegistry: pc.AssetRegistry, urlPrefix: string = "", maxParallelDownloads: number = 32) {
        this._assetRegistry = assetRegistry;
        this._urlPrefix = urlPrefix;
        this._maxPrlDownloads = maxParallelDownloads;

        this._queue = [];
        this._queueSize = 0;

        this._isLoading = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    addAsset(name: string, type: pc.eAssetType, url: string): pc.Asset {
        let asset = new pc.Asset(name, type, { url: this._urlPrefix + url });

        this._queue[this._queueSize++] = asset;
        return asset;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    load(): void {
        if (this._isLoading || this._queueSize == 0)
            return;

        this._isLoading = true;
        this._queuePos = 0;
        this._loadedCnt = 0;
        this._prlDownloads = 0;

        while (this._prlDownloads < this._maxPrlDownloads && this._queuePos < this._queueSize) {
            this.loadNextAsset();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private loadNextAsset(): void {
        // Ziskat asset z fronty
        let asset = this._queue[this._queuePos++];

        // Pridat asset do registru
        this._assetRegistry.add(asset);

        // Nacist asset
        this._prlDownloads++;

        this._assetRegistry.loadFromUrl(asset.file.url, asset.type, (err: string, asset: pc.Asset) => {
            this._prlDownloads--;
            this._loadedCnt++;

            if (this._queuePos < this._queueSize) {
                // Zahajit nacteni dalsiho assetu
                this.loadNextAsset();
            }
            else if (this._loadedCnt == this._queueSize) {
                this._queue.length = 0;
                this._queueSize = 0;
                this._isLoading = false;

                // Vsechny assety byly nacteny
                this._assetRegistry.fire(AssetLoader.EVENT_LOADED, this, this._loadedCnt);
            }
        });
    }
}